import { useCallback, useEffect, useRef, useState } from 'react';
import { adminAPI } from '../lib/api';
import type { FiatCurrency } from '../lib/typicalV2';

export function useAdminMerchants(active: boolean) {
    const [merchants, setMerchants] = useState<any[]>([]);
    const [pagination, setPagination] = useState({ page: 1, total: 0, pages: 1 });
    const [filters, setFilters] = useState({ page: 1, search: '', currency: '' as FiatCurrency | '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const requestId = useRef(0);
    const currentFilters = useRef(filters);
    currentFilters.current = filters;

    const refresh = useCallback(async () => {
        if (filters !== currentFilters.current) return;
        const id = ++requestId.current;
        setLoading(true);
        setError(null);
        try {
            const result = await adminAPI.getMerchants(
                filters.page, 50, true, filters.search || undefined, filters.currency || undefined,
            );
            if (id !== requestId.current || filters !== currentFilters.current) return;
            setMerchants(result.items);
            setPagination({ page: result.page, total: result.total, pages: result.pages });
        } catch (err) {
            if (id === requestId.current) setError('Не удалось загрузить список мерчантов');
        } finally {
            if (id === requestId.current) setLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        if (active) void refresh();
        return () => { requestId.current += 1; };
    }, [active, refresh]);

    return { merchants, setMerchants, pagination, filters, setFilters, loading, error, refresh };
}
